// TODO: Abstract the use of these images to use vector-image service
import iconImage from './assets/Night.png';

const { host } = window.location;
let domain = host;
if (host !== 'deckee.com') domain = 'staging.deckee.com';

export default {
  displayName: 'Night',
  iconImage,
  subscriberOnly: true,
  iconBackgroundColor: '#ADE1FE',
  style: `https://${domain}/public/map-tile-server/map-styles/night.json`,
};
